module.exports = __webpack_public_path__ + "static/media/ntakos_full2.98c6078a.jpg";